var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chat" }, [
    _c(
      "ul",
      [
        _c(
          "transition-group",
          { attrs: { name: "list", tag: "p" } },
          _vm._l(_vm.list, function (m, i) {
            return _c("li", { key: i }, [
              _c(
                "div",
                { staticClass: "icon", class: { meicon: m.type === "me" } },
                [_vm._v(_vm._s(m.type))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "msg", class: { me: m.type === "me" } },
                [_vm._v(_vm._s(m.msg))]
              ),
            ])
          }),
          0
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }